import { useState } from "react";
import ThemeToggle from "./ThemeToggle";

const RESUME_URL =
  "https://drive.google.com/file/d/1MBbLD4Q_64csf83USYHgISYspyUl3cC8/view?usp=drive_link";

const LINKS = [
  { href: "#experience", label: "Experience" },
  { href: "#work", label: "Work" },
  { href: "#skills", label: "Skills" },
  { href: "#leadership", label: "Leadership" },
  { href: "#about", label: "About" },
  { href: "#contact", label: "Contact" },
];

function Nav() {
  const [menuOpen, setMenuOpen] = useState(false);

  return (
    <nav>
      <div className="nav-inner">
        <a className="brand" href="#top">
          <span className="dot" />
          Shreyansh Koladiya
        </a>
        <div className="nav-links">
          {LINKS.map((link) => (
            <a key={link.href} href={link.href}>
              {link.label}
            </a>
          ))}
          <a
            className="btn sm ghost"
            href={RESUME_URL}
            target="_blank"
            rel="noreferrer"
          >
            Resume
          </a>
          <div className="nav-controls">
            <ThemeToggle />
          </div>
        </div>
        <button
          type="button"
          className="nav-menu-btn"
          aria-label="Toggle menu"
          aria-expanded={menuOpen}
          onClick={() => setMenuOpen((open) => !open)}
        >
          <svg
            width="18"
            height="18"
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth="2"
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden="true"
          >
            <path d="M4 6h16M4 12h16m-7 6h7" />
          </svg>
        </button>
      </div>
      <div className={`nav-mobile-menu${menuOpen ? " open" : ""}`}>
        {LINKS.map((link) => (
          <a
            key={link.href}
            href={link.href}
            onClick={() => setMenuOpen(false)}
          >
            {link.label}
          </a>
        ))}
        <a href={RESUME_URL} target="_blank" rel="noreferrer">
          Resume
        </a>
        <div className="nav-controls">
          <ThemeToggle />
        </div>
      </div>
    </nav>
  );
}

export default Nav;
